import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "motion/react";
import type { LucideIcon } from "lucide-react";
import type { SitePage } from "./searchPages";

interface SearchPagesResultsProps {
  pages: SitePage[];
  textAlign: string;
  ChevronDir: LucideIcon;
  onItemClick: () => void;
  t: (key: string, fallback: string) => string;
}

/** Pill list of site pages matching the current query. */
export const SearchPagesResults = ({
  pages,
  textAlign,
  ChevronDir,
  onItemClick,
  t,
}: SearchPagesResultsProps) => {
  return (
    <div className="mb-4 sm:mb-6">
      <h3 className={`text-sm font-medium text-muted-foreground mb-2 sm:mb-3 ${textAlign}`}>
        {t("sitePages", "עמודים באתר")}
      </h3>
      <div className="flex flex-wrap gap-2">
        <AnimatePresence mode="popLayout">
          {pages.map((page, index) => {
            const IconComp = page.icon;
            return (
              <motion.div
                key={page.path}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.15, delay: index * 0.02 }}
              >
                <Link
                  to={page.path}
                  onClick={onItemClick}
                  className="group flex items-center gap-2 px-3 sm:px-4 py-1.5 sm:py-2 rounded-full border border-border/50 bg-background hover:border-primary/50 hover:bg-primary/5 transition-all duration-200"
                >
                  <IconComp className="h-4 w-4 text-primary" />
                  <div className="flex flex-col">
                    <span className="text-xs sm:text-sm group-hover:text-primary transition-colors">
                      {page.name}
                    </span>
                    <span className="text-[10px] text-muted-foreground/70 hidden sm:block">
                      {page.description}
                    </span>
                  </div>
                  <ChevronDir className="h-3 w-3 sm:h-4 sm:w-4 text-muted-foreground group-hover:text-primary transition-colors" />
                </Link>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    </div>
  );
};
